import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const PATIENT_DATA_RANGES = [7, 30, 90, 180, 365] as const;
export type PatientDateRange = typeof PATIENT_DATA_RANGES[number];

interface PatientDateRangeSelectorProps {
  value: PatientDateRange;
  onChange: (range: PatientDateRange) => void;
}

export default function PatientDateRangeSelector({ value, onChange }: PatientDateRangeSelectorProps) {
  const { t } = useTranslation();

  return (
    <Box
      role="group"
      aria-label={String(t('date_range', 'Date range') ?? 'Date range')}
      sx={{ display: 'flex', gap: 0.5, p: 0.5, bgcolor: 'grey.100', borderRadius: 1, alignItems: 'center' }}
    >
      {PATIENT_DATA_RANGES.map((range) => (
        <Box
          key={range}
          component="button"
          type="button"
          aria-pressed={value === range}
          onClick={() => onChange(range)}
          sx={{
            border: 'none',
            bgcolor: value === range ? 'grey.300' : 'transparent',
            color: value === range ? 'text.primary' : 'text.secondary',
            px: 1,
            py: 0.4,
            borderRadius: 0.75,
            fontSize: '0.7rem',
            fontWeight: 600,
            lineHeight: 1.2,
            cursor: 'pointer',
            minWidth: '28px'
          }}
        >
          {range}d
        </Box>
      ))}
    </Box>
  );
}